<div class="modal-header border-0 px-lg-8 px-2">
	<span class="modal-title theme-main-color fs-4 fw-bold ms-2 mt-3"
		>Modification</span
	>
	<button
		type="button"
		class="btn-close"
		data-bs-dismiss="modal"
		aria-label="Close"
		(click)="bsModalRef.hide()"
	></button>
</div>

<div class="modal-body">
	<div class="row px-lg-8 px-2">
		<div class="">
			<div class="row">
				<span class="theme-main-color fs-4 col">Informations</span>
				<button
					class="col-2 btn theme-red-button"
					(click)="openModal(deleteRegion)"
				>
					<i class="bi bi-trash-fill" aria-hidden="true"></i>
				</button>
			</div>
			<div class="row my-2">
				<form id="formEdit" [formGroup]="formEdit" (ngSubmit)="onSubmit()">
					<div class="row my-4">
						<label for="name" class="form-label theme-main-color fw-bold"
							>Nom</label
						>
						<input
							autocomplete="off"
							type="text"
							class="form-control"
							id="name"
							name="name"
							formControlName="name"
							[ngClass]="{
								'is-invalid': name.invalid,
								'is-valid': name.dirty && name.valid
							}"
						/>
					</div>
					<div class="row my-4">
						<label for="sigle" class="form-label theme-main-color fw-bold"
							>Sigle</label
						>
						<input
							autocomplete="off"
							type="text"
							class="form-control"
							id="sigle"
							name="sigle"
							formControlName="sigle"
							[ngClass]="{
								'is-invalid': sigle.invalid,
								'is-valid': sigle.dirty && sigle.valid
							}"
						/>
					</div>

					<div class="row my-4">
						<div class="col-12 col-lg">
							<label for="departements" class="form-label fw-bold">Départements</label>
							<div class="row">
								<div
									class="col-md-4 check"
									*ngFor="let departement of listDepartement | orderBy : 'name' : 'asc'"
								>
								<div *ngIf="departement.id !== 0">
									<input
										type="checkbox"
										name="{{ departement.id }}"
										class="form-check-input"
										[value]="departement"
										[checked]="isDepartementCheck(departement)"
										[ngClass]="{
											'theme-main-color-check': isDepartementCheck(departement)
										}"
										(change)="updateSelectedDepartement($event, departement)"
									/>
									<label class="ms-2 form-check-label text-dark">
										{{ departement.name + ' ' +departement.code}}
									</label>
								</div>
							</div>
							</div>
						</div>
				
					</div>

					<div class="row my-5">
						<div class="d-flex justify-content-end">
							<button
								class="btn theme-main-color-button mx-3 px-3"
								type="button"
								(click)="bsModalRef.hide()"
							>
								Retour
							</button>
							<button
								[disabled]="!formEdit.valid || isValidateButtonClicked"
								class="btn theme-green-button"
								type="submit"
								form="formEdit"
							>
								<i class="bi bi-save-fill px-1" aria-hidden="true"></i
								>Sauvegarder
							</button>
						</div>
					</div>
				</form>
			</div>
		</div>
	</div>
</div>

<ng-template #deleteRegion>
	<div class="modal-header text-center">
		<h4>Suppression du niveau de qualification</h4>
		<button
			type="button"
			class="btn-close"
			aria-label="Close"
			(click)="confirmDeleteModalRef.hide()"
		></button>
	</div>
	<div class="modal-body">
		Êtes-vous sûr de vouloir supprimer le niveau de qualification ?
	</div>
	<div class="modal-footer">
		<a
			(click)="confirmDeleteModalRef.hide()"
			class="btn theme-main-color-button"
			>Retour</a
		>
		<a class="btn theme-red-button ms-3" (click)="delete()">Supprimer</a>
	</div>
</ng-template>
